module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av334-2a8aa84d35347dd1bec41f5881c924a1.jpg";